import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renderiza o texto do assistente como markdown de verdade (GFM): tabelas, listas,
 * negrito, links. Substitui o formatMarkdown custom (que não fazia tabela) na bolha do
 * agente — assim a LLM decide o formato (texto/tabela/lista) e o front renderiza.
 * Estilo alinhado ao chat; tabela ganha scroll horizontal em telas estreitas.
 */
export function MarkdownMessage({ content }: { content: string }) {
  if (!content?.trim()) return null;
  return (
    <div className="text-md leading-relaxed text-darkgray-600">
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          strong: ({ children }) => (
            <strong className="font-semibold text-darkgray-900">
              {children}
            </strong>
          ),
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-aiBlue-600 underline hover:text-aiBlue-700"
            >
              {children}
            </a>
          ),
          ul: ({ children }) => (
            <ul className="mb-2 list-disc space-y-0.5 pl-5 last:mb-0">
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol className="mb-2 list-decimal space-y-0.5 pl-5 last:mb-0">
              {children}
            </ol>
          ),
          h1: ({ children }) => (
            <p className="mb-1 mt-2 text-md font-semibold text-darkgray-900">
              {children}
            </p>
          ),
          h2: ({ children }) => (
            <p className="mb-1 mt-2 text-md font-semibold text-darkgray-900">
              {children}
            </p>
          ),
          h3: ({ children }) => (
            <p className="mb-1 mt-2 text-md font-semibold text-darkgray-900">
              {children}
            </p>
          ),
          table: ({ children }) => (
            <div className="my-2 w-full overflow-x-auto rounded-xl border border-lightgray-300 my-3">
              <table className="w-full border-collapse text-sm bg-white">
                {children}
              </table>
            </div>
          ),
          thead: ({ children }) => (
            <thead className="border-b border-lightgray-300 bg-lightgray-100">
              {children}
            </thead>
          ),
          th: ({ children, style }) => (
            <th
              style={style}
              className="whitespace-nowrap px-3 py-2 text-left text-sm font-semibold text-darkgray-600"
            >
              {children}
            </th>
          ),
          td: ({ children, style }) => (
            <td
              style={style}
              className="whitespace-nowrap border-t border-lightgray-300 px-3 py-2 align-top text-darkgray-700"
            >
              {children}
            </td>
          ),
        }}
      >
        {content}
      </Markdown>
    </div>
  );
}
